var wishlistPageUrl = window.location.pathname;
if (wishlistPageUrl == '/a/wishlist') {
  var wishlistLoadedTwo = false;
  function getCookie(name) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
      let [k,v] = el.split('=');
      cookie[k.trim()] = v;
    })
    return cookie[name];
  }
    document.addEventListener('DOMNodeInserted', function(e) {
      var scriptWaiting = document.querySelectorAll('script')
      var scriptFound = false
      for (item of scriptWaiting){
        if(item.src.includes('getproductdetails.php')){
          scriptFound = true
        }
      }
      if(scriptFound && !wishlistLoadedTwo){
        wishlistLoadedTwo = true
        setTimeout( () => {
          var wishlistid;
          if(getCookie("wishlist_id")){
            wishlistid = getCookie("wishlist_id")
            console.log('get in  if')
          } else {
            wishlistid = SWGetExpressWishlistId()
          }
          var isLogin = getCookie('wishlist_customer_id') != 0 ? true : false
          var wishlistParams = ''
          if(!isLogin){
            wishlistParams = `wishlistid=${wishlistid}`
          } else {
            wishlistParams = `customerid=${getCookie('wishlist_customer_id')}`
          }
            $.ajax({
              url: "/a/wishlist?type=api&"+wishlistParams+"&version=1",dataType: "json",cache:false,
              success: function(data) {
                data.items.map((item) => {
                  var oldButtons = document.querySelector(`.addsingleproduct[data-variantid="${item.variant_id}"]`)
                  var newCartButton = `<div data-component="buy-buttons" data-component-type="component" class="buy-buttons">
                    <script type="application/json" data-component-data="">
                        {
                            "unavailable": "Unavailable",
                            "soldOut": "Special Order",
                            "addToCart": "Add to Cart"
                        }
                    </script>
                    <form id="${item.variant_id}" method="post" action="/cart/add" accept-charset="UTF-8"
                        class="buy-buttons__form" enctype="multipart/form-data"><input type="hidden" name="form_type"
                            value="product"><input type="hidden" name="utf8" value="✓">
                        <div class="buy-buttons__buttons">
                            <div data-component="notification" data-component-type="component" class="
                                                notification
                                                notification--error wishlist-notification
                                              " role="alert"  hidden="">
                
                            </div>
                            <input id="order-type" type="hidden" name="properties[Order Type]" value="In Stock">
                            <input id="variant-id" type="hidden" name="id" value="${item.variant_id}">
                            <input id="quantity" type="hidden" name="quantity" value="1">
                            <button data-component="button-action" data-component-type="component" data-sn="DQ-21-3304"
                                class="button-action add-cart-trigger btn btn-primary addbutton button-action--primary custom-add-to-cart"
                                aria-busy="false" aria-live="polite">
                                Add to Cart
                            </button>
                        </div>
                        <div data-component="surface-pick-up" data-component-type="component"
                            class="surface-pick-up surface-pick-up--hidden">
                            <template data-drawer-header-template="">
                                <h2 class="h4 surface-pick-up-drawer__heading">${item.title}</h2>
                                <span class="surface-pick-up-drawer__subheading">${item.variant_title}</span>
                            </template>
                            <template data-drawer-template="">
                                <div data-component="surface-pick-up-drawer" data-component-type="component"
                                    class="surface-pick-up-drawer">
                                </div>
                            </template>
                        </div>
                    </form>
                </div>`
                  oldButtons.insertAdjacentHTML('afterend', newCartButton);
                  document.querySelectorAll('button.custom-add-to-cart').forEach((el) => {
                    el.addEventListener('click', function() {
                      document.querySelectorAll('.wishlist-notification').forEach((notif)=> {
                        notif.setAttribute("hidden", "")
                      })
                    })
                  })
                })
              }
            });
        }, 0)
      }
    });
}
